import React from 'react';

import { connect } from 'react-redux';

import { MembershipActionLocation } from '../../constants/checkout';
import { useLDNewShoppingBagUX } from '../../utils/LD/useNewShoppingBagUX';
import { getGwpProduct } from '../../utils/selectors';
import withMembershipPrice from '../../utils/withMembershipPrice';
import NewBasketItemList from '../ShoppingBagBasketItemList/NewShoppingBagBasketItemList';

import BasketItemList from './BasketItemList';

const mapStateToProps = (state, ownProps) => {
  return {
    gwpProduct: getGwpProduct(state),
    order: ownProps.order || state.checkout,
  };
};

function BasketItemListContainer(props) {
  const { isControl } = useLDNewShoppingBagUX();
  const { location } = props;

  if (!isControl && location === MembershipActionLocation.MINI_CART) {
    return <NewBasketItemList {...props} />;
  }
  return <BasketItemList {...props} />;
}

export default connect(mapStateToProps)(
  withMembershipPrice(BasketItemListContainer)
);
